var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLwsLogoDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 309.63 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #171c2a;\n      }\n\n      .cls-2 {\n        fill: #00d991;\n      }\n\n      .cls-3, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill-rule: evenodd;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LWS Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New_Version",
    "data-name": "New Version"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "RoundShape",
    className: "cls-1",
    cx: 50,
    cy: 50,
    r: 48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50,100a50,50,0,1,1,50-50A50.06,50.06,0,0,1,50,100ZM50,4A46,46,0,1,0,96,50,46.06,46.06,0,0,0,50,4Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Full_Logo",
    "data-name": "Full Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 39.89,
    y: 52.88,
    width: 1.17,
    height: 6.91,
    rx: 0.38,
    transform: "translate(-27.99 45.17) rotate(-45.04)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 39.6,
    y: 50.81,
    width: 1.17,
    height: 5.84,
    rx: 0.38,
    transform: "translate(-26.22 44.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 64.46,
    y: 52.89,
    width: 1.17,
    height: 6.91,
    rx: 0.38,
    transform: "translate(-20.78 62.56) rotate(-45.04)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 64.15,
    y: 50.81,
    width: 1.17,
    height: 5.84,
    rx: 0.38,
    transform: "translate(-19.04 61.44) rotate(-44.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73,56.45H72a9.83,9.83,0,0,0-19.49-.23c-.53.12-2.6.23-2.6.23s-2-.1-2.49-.21a9.83,9.83,0,0,0-19.49.21H26.81a.76.76,0,0,0-.76.76V58a.76.76,0,0,0,.75.75h1.08A9.83,9.83,0,0,0,47.37,59c.55-.11,2.49-.22,2.49-.22s2.06.13,2.6.24A9.83,9.83,0,0,0,72,58.79h1a.76.76,0,0,0,.76-.74h0v-.83a.76.76,0,0,0-.76-.76ZM37.64,65.11a7.49,7.49,0,1,1,7.49-7.49h0A7.49,7.49,0,0,1,37.64,65.11Zm24.55,0a7.49,7.49,0,1,1,7.49-7.49h0A7.49,7.49,0,0,1,62.19,65.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.58,53.62V36.13H75.43a43.8,43.8,0,0,0,.69-5.82L72.5,33c2-2.31,0-13.08,0-13.08s-2.64,5.18-19.1,3.86S34.63,29,34.63,29c-2-2,0-5.27,0-5.27a5,5,0,0,0-2.44,6.64l.14.27H27L30.68,33a6.7,6.7,0,0,0-2.55,3.18h-9.9V53.62l-3.6,3.6,3.6,3.6,1,17.49h9.35l-1-18.51a.46.46,0,0,0-.4-.53.47.47,0,0,0-.53.39.33.33,0,0,0,0,.14V74H22.46V59.66L20,57.22l2.45-2.44V40.44h4.66a19.7,19.7,0,0,0-.06,3.26h3.29A7.71,7.71,0,0,1,33,38.55c5.6-6.92,29.31-2.88,29.31-2.88l2.63-3.88-1,3.88C69.52,37,70,43.58,70,43.58h2.5a11,11,0,0,0,1.75-3.14h3.1V54.78l2.45,2.44-2.45,2.44V74H72.23l1,4.31h9.35l-1-17.49,3.6-3.6Z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.32,37.78h8.05v3.88h-13V17.23h4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M158.37,33.44H144.19a4.86,4.86,0,0,0,1.47,3.29,4.54,4.54,0,0,0,3.19,1.19,4,4,0,0,0,3.88-2.35H158a8.84,8.84,0,0,1-3.22,4.6A9.37,9.37,0,0,1,149,42a10.08,10.08,0,0,1-5-1.25,8.75,8.75,0,0,1-3.47-3.51A10.78,10.78,0,0,1,139.22,32a11,11,0,0,1,1.23-5.29,8.51,8.51,0,0,1,3.43-3.5A10.23,10.23,0,0,1,149,22a10.12,10.12,0,0,1,5,1.19,8.36,8.36,0,0,1,3.4,3.37,10.31,10.31,0,0,1,1.21,5A12,12,0,0,1,158.37,33.44Zm-4.94-3.29a3.9,3.9,0,0,0-1.36-3A4.85,4.85,0,0,0,148.81,26a4.47,4.47,0,0,0-3.06,1.1,4.83,4.83,0,0,0-1.52,3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M162,26.68a8.58,8.58,0,0,1,3.18-3.5,8.44,8.44,0,0,1,4.5-1.22,8,8,0,0,1,3.8.87,7.63,7.63,0,0,1,2.6,2.21V22.27H181V41.66h-4.94V38.83a7.27,7.27,0,0,1-2.6,2.25,8,8,0,0,1-3.84.9,8.24,8.24,0,0,1-4.46-1.26A8.82,8.82,0,0,1,162,37.16a11.39,11.39,0,0,1-1.18-5.26A11.28,11.28,0,0,1,162,26.68Zm13.38,2.22a4.89,4.89,0,0,0-1.89-2,5.07,5.07,0,0,0-2.55-.68,4.93,4.93,0,0,0-4.39,2.61,6.06,6.06,0,0,0-.72,3,6.29,6.29,0,0,0,.72,3.06,5.1,5.1,0,0,0,1.89,2,4.75,4.75,0,0,0,2.5.7,5.07,5.07,0,0,0,2.55-.68,4.89,4.89,0,0,0,1.89-2,6.23,6.23,0,0,0,.7-3.06A6.3,6.3,0,0,0,175.37,28.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M193.17,22.87a6.82,6.82,0,0,1,3.48-.88v5.15h-1.29a5,5,0,0,0-3.48,1.08c-.79.72-1.17,2-1.17,3.78v9.66H185.8V22.27h4.91v3A6.76,6.76,0,0,1,193.17,22.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M216.29,24.18a8.38,8.38,0,0,1,2.13,6.11V41.66h-4.9V31a5,5,0,0,0-1.15-3.55,4.08,4.08,0,0,0-3.15-1.24A4.18,4.18,0,0,0,206,27.4,4.94,4.94,0,0,0,204.84,31V41.66h-4.9V22.27h4.9v2.42a6.83,6.83,0,0,1,2.51-2,7.7,7.7,0,0,1,3.34-.72A7.46,7.46,0,0,1,216.29,24.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.29,60.27l-5.67,19.39h-5.28L136.8,66.12l-3.53,13.54H128l-5.7-19.39h5L130.64,75l3.72-14.77h5.18L143.17,75l3.44-14.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M154.29,57.14a2.87,2.87,0,0,1,0-4.1,3.23,3.23,0,0,1,4.3,0,2.87,2.87,0,0,1,0,4.1,3.23,3.23,0,0,1-4.3,0Zm4.57,3.13V79.66H154V60.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M169.39,64.29v9.38a1.87,1.87,0,0,0,.47,1.42,2.34,2.34,0,0,0,1.59.44h2.28v4.13h-3.08q-6.19,0-6.2-6V64.29h-2.31v-4h2.31V55.48h4.94v4.79h4.34v4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M192.1,61a6.58,6.58,0,0,1,2.68,2.84,9.77,9.77,0,0,1,1,4.5V79.66h-4.9V69a5,5,0,0,0-1.15-3.55,4.08,4.08,0,0,0-3.15-1.24,4.18,4.18,0,0,0-3.2,1.24A4.94,4.94,0,0,0,182.17,69V79.66h-4.91V53.76h4.91v8.93a6.3,6.3,0,0,1,2.51-2,8.33,8.33,0,0,1,3.5-.72A7.88,7.88,0,0,1,192.1,61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M212.56,79a7.58,7.58,0,0,1-3.24-2.52,6.64,6.64,0,0,1-1.22-3.89h5.25A3.34,3.34,0,0,0,214.42,75a3.74,3.74,0,0,0,2.64.88,4,4,0,0,0,2.69-.82,2.66,2.66,0,0,0,1-2.15,2.5,2.5,0,0,0-.66-1.79,4.73,4.73,0,0,0-1.66-1.1,27.89,27.89,0,0,0-2.75-.9,27.66,27.66,0,0,1-3.87-1.38,6.71,6.71,0,0,1-2.55-2.06A5.82,5.82,0,0,1,208.17,62a6.61,6.61,0,0,1,1.08-3.78,6.88,6.88,0,0,1,3.05-2.47,11.08,11.08,0,0,1,4.48-.86,9.67,9.67,0,0,1,6.14,1.84,6.77,6.77,0,0,1,2.61,5.13h-5.39a2.81,2.81,0,0,0-1.07-2.09,4,4,0,0,0-2.64-.82,3.39,3.39,0,0,0-2.29.74,2.63,2.63,0,0,0-.86,2.13,2.19,2.19,0,0,0,.65,1.63,4.89,4.89,0,0,0,1.61,1,27.87,27.87,0,0,0,2.71.93,27.27,27.27,0,0,1,3.88,1.4,6.77,6.77,0,0,1,2.59,2.1,5.77,5.77,0,0,1,1.09,3.67,6.88,6.88,0,0,1-1,3.64,7.19,7.19,0,0,1-3,2.68,10.23,10.23,0,0,1-4.66,1A11.68,11.68,0,0,1,212.56,79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M248.35,60.27V79.66h-4.94V77.21a6.5,6.5,0,0,1-2.46,2,7.66,7.66,0,0,1-3.31.72,8.26,8.26,0,0,1-4-1,6.75,6.75,0,0,1-2.74-2.83,9.32,9.32,0,0,1-1-4.46V60.27h4.9V71a5,5,0,0,0,1.15,3.55,4.08,4.08,0,0,0,3.15,1.24,4.13,4.13,0,0,0,3.19-1.24A5,5,0,0,0,243.41,71V60.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M283,62.18a8.28,8.28,0,0,1,2.18,6.11V79.66h-4.9V69a4.82,4.82,0,0,0-1.15-3.48A4.14,4.14,0,0,0,276,64.26a4.2,4.2,0,0,0-3.17,1.21A4.79,4.79,0,0,0,271.66,69V79.66h-4.9V69a4.83,4.83,0,0,0-1.16-3.48,4.14,4.14,0,0,0-3.15-1.21,4.24,4.24,0,0,0-3.2,1.21A4.79,4.79,0,0,0,258.08,69V79.66h-4.9V60.27h4.9v2.35a6.54,6.54,0,0,1,2.43-1.93,7.52,7.52,0,0,1,3.27-.7,8.43,8.43,0,0,1,4.06,1,6.73,6.73,0,0,1,2.77,2.75A6.92,6.92,0,0,1,273.36,61,8.38,8.38,0,0,1,283,62.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M290.19,57.14a2.87,2.87,0,0,1,0-4.1,3.24,3.24,0,0,1,4.31,0,2.9,2.9,0,0,1,0,4.1,3.24,3.24,0,0,1-4.31,0Zm4.57,3.13V79.66h-4.9V60.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M305.29,64.29v9.38a1.83,1.83,0,0,0,.48,1.42,2.31,2.31,0,0,0,1.59.44h2.27v4.13h-3.08q-6.19,0-6.19-6V64.29h-2.31v-4h2.31V55.48h4.93v4.79h4.34v4Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLwsLogoDark);
export default __webpack_public_path__ + "static/media/lws-logo-dark.70a060d2626bd1c9398edde22f1bd0d8.svg";
export { ForwardRef as ReactComponent };